// Team chat's Direct messages group (polish round two, the founder's order of 2026-10-16, brief `docs/briefs/polish-round-two.md` item two:
// "recency, not a roster"): the heading's one control, the "+" "New message", which opens a people search at `?dialog=new-message`; and
// the column's "Show all" / "Show fewer" (`?dms=all`, kept on reload). Which conversations the folded list holds is the pure rule
// `directMessages` (lib/chatRooms.ts); a DM is still made by its first message, on the conversation's own address.
import { useState } from "react";
import { Button, Dialog, Lookup } from "@omnabase/ui";
import { useSession } from "../../shell/store";
import { currentParams, useNavigate, useParamNow, useSetParam, useWs } from "../../lib/nav";
import { messageable } from "../../lib/chatRooms";

const DIALOG = "new-message";

/** What the chat screen hands the column and the page for the Direct messages group: whether "Show all" is open, the switch between the
 *  two lists, the heading's "+", and the "New message" dialog while its address asks for it. */
export function useDmColumn() {
  const setParam = useSetParam();
  const all = useParamNow("dms") === "all";
  const asked = useParamNow("dialog") === DIALOG; // opened from the address, not on the click itself: the address says so once it shows
  return {
    all,
    toggle: () => setParam("dms", currentParams().get("dms") === "all" ? null : "all"),
    plus: <Button variant="icon" size="sm" icon="plus" aria-label="New message" title="New message" onClick={() => setParam("dialog", DIALOG)} />,
    dialog: asked ? <NewMessageDialog onClose={() => setParam("dialog", null)} /> : null,
  };
}

/** "New message": the kit's Lookup over the active colleagues (never yourself); choosing one opens that conversation's address, where the
 *  first message makes the DM ("Say hello to …"), as the column and `/dm` do. */
function NewMessageDialog({ onClose }: { onClose: () => void }) {
  const { workspace, me } = useSession();
  const { ws } = useWs();
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const options = messageable(workspace.members, me.user.id, query).map((m) => ({ id: m.userId, title: m.name, initials: m.initials }));
  return (
    <Dialog title="New message" intro="Find a colleague by name. The conversation starts with your first message." onClose={onClose} width={480} footer={<Button onClick={onClose}>Cancel</Button>}>
      <div className="ob-newticket__fields">
        <label className="ob-newticket__row"><span className="ob-newticket__label">To</span>
          <Lookup label="Colleague" placeholder="A colleague's name" query={query} onQuery={setQuery} options={options} onPick={(userId) => navigate(ws(`/chat/dm/${userId}`))}
            onClear={() => setQuery("")} empty="No active colleague by that name." autoFocus />
        </label>
      </div>
    </Dialog>
  );
}
